import { object, string } from 'yup'

const requiredString = () => string().trim().required('This field is required')

export default object().shape({
  name: requiredString(),
})
